// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"22":"124b5f5e","142":"fa7393d1","312":"95e58e49","419":"179deee9","527":"4829092d","714":"8b9d6b12"}[chunkId] + ".chunk.js";
};